"use client";

import { Box, Container, Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Preloader from "../components/common/Preloader";
import { getCurrentDomain } from "../components/common/utils";
import BlogsContainer from "../components/containers/BlogsContainer";
import BlogsGrid from "../components/layouts/BlogsGrid";
import useTostify from "../hooks/useTostify";

const Blogs = () => {
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get("category");

  const { setNotification } = useTostify();
  const [loadingBlogs, setLoadingBlogs] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(
    categoryParam || "All"
  );

  useEffect(() => {
    // Fetch categories for the filter
    axios
      .get(`${getCurrentDomain()}/categories`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setCategories(
            res.data.filter((cat) => cat.trips && cat.trips.length > 0)
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching categories:", err);
      });
  }, []);

  useEffect(() => {
    setLoadingBlogs(true);

    // Fetch all blogs, optionally filtered by category
    const params = categoryParam ? { category: categoryParam } : {};

    axios
      .get(`${getCurrentDomain()}/blogs`, { params })
      .then((res) => {
        if (res.data && res.data.success) {
          setBlogs(res.data.data || []);
        } else {
          setBlogs([]);
        }
        setLoadingBlogs(false);
      })
      .catch((err) => {
        setNotification({
          open: true,
          severity: "error",
          msg: "Error while fetching blogs!",
        });
        setBlogs([]);
        setLoadingBlogs(false);
      });
  }, [categoryParam, setNotification]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    // Update URL with the selected category
    const newSearchParams = new URLSearchParams(searchParams);
    if (category === "All") {
      newSearchParams.delete("category");
    } else {
      newSearchParams.set("category", category);
    }
    window.history.pushState(
      {},
      "",
      `${window.location.pathname}?${newSearchParams.toString()}`
    );

    // Fetch blogs for the selected category
    setLoadingBlogs(true);
    const params = category === "All" ? {} : { category };

    axios
      .get(`${getCurrentDomain()}/blogs`, { params })
      .then((res) => {
        if (res.data && res.data.success) {
          setBlogs(res.data.data || []);
        } else {
          setBlogs([]);
        }
        setLoadingBlogs(false);
      })
      .catch((err) => {
        setNotification({
          open: true,
          severity: "error",
          msg: "Error while fetching blogs!",
        });
        setBlogs([]);
        setLoadingBlogs(false);
      });
  };

  return (
    <>
      {loadingBlogs ? (
        <Grid container justifyContent="center">
          <Grid item pt={5} pb={5}>
            <Preloader />
          </Grid>
        </Grid>
      ) : (
        <>
          <BlogsContainer>
            <Container maxWidth="lg">
              {/* <Typography
                variant="h4"
                component="h1"
                sx={{
                  textAlign: "center",
                  my: 4,
                  fontWeight: 600,
                }}
              >
                {selectedCategory === "All" ? "All Blogs" : `${selectedCategory} Blogs`}
              </Typography> */}

              {/* Category filter */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  mb: 4,
                  justifyContent: "center",
                }}
              >
                {/* <Button
                  variant={
                    selectedCategory === "All" ? "contained" : "outlined"
                  }
                  color="primary"
                  size="small"
                  onClick={() => handleCategoryChange("All")}
                  sx={{ borderRadius: 2 }}
                >
                  All
                </Button>
                {categories.map((category) => (
                  <Button
                    key={category._id}
                    variant={
                      selectedCategory === category.categoryName
                        ? "contained"
                        : "outlined"
                    }
                    color="primary"
                    size="small"
                    onClick={() => handleCategoryChange(category.categoryName)}
                    sx={{ borderRadius: 2 }}
                  >
                    {category.categoryName}
                  </Button>
                ))} */}
              </Box>

              {/* Blog list view */}
              <Box
                sx={{
                  padding: 0,
                  justifyContent: "center",
                  alignItems: "center",
                  marginX: { xs: 0, md: 2 },
                }}
              >
                <BlogsGrid blogs={blogs} loadingBlogs={loadingBlogs} />
              </Box>
            </Container>
          </BlogsContainer>
        </>
      )}
    </>
  );
};

export default Blogs;
